import React from "react";
import {
  Link,
  Outlet,
  createFileRoute,
  useLocation,
} from "@tanstack/react-router";

import { Card } from "~/components/ui/card";
import { Breadcrumb } from "~/components/ui/breadcrumb";

export const Route = createFileRoute("/_user/settings/profile")({
  component: ProfileLayout,
});

function ProfileLayout() {
  const location = useLocation();

  const tabs = [
    { title: "General Info", href: "/settings/profile/" },
    {
      title: "Coach Preferences",
      href: "/settings/profile/coaching-preferences/",
    },
  ];

  return (
    <>
      <div className="mb-10.5 relative mx-auto my-4 flex w-full max-w-screen-xl flex-col overflow-visible px-4 md:mt-8">
        <Breadcrumb
          items={[
            { label: "Settings", href: "/settings/" },
            {
              label: location.pathname.includes("coaching-preferences")
                ? "Coach Preferences"
                : "General Info",
              href: location.pathname,
            },
          ]}
          size="3xl"
          isHeading
          variant="chevrons"
          useGrayLinks={false}
        />
        <div className="grid grid-cols-12 gap-6">
          <Card className="col-span-3 h-fit p-4 shadow-none hover:shadow-none">
            <div className="flex flex-col bg-white">
              {tabs.map((tab) => (
                <Link
                  key={tab.href}
                  className={`relative flex h-16 w-fit items-center px-4 py-3 text-left font-semibold transition-all ${
                    location.pathname === tab.href
                      ? "text-text-primary/100"
                      : "text-gray-500"
                  }`}
                  to={tab.href}
                >
                  {tab.title}
                  {/* Left Line for Active and Inactive State */}
                  <span
                    className={`absolute left-0 top-0 h-full w-0.5 transition-all duration-300 ${
                      location.pathname === tab.href
                        ? "bg-primary/100 scale-y-100"
                        : "bg-gray-300"
                    }`}
                  ></span>
                </Link>
              ))}
            </div>
          </Card>

          <div className="col-span-9">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
